export default "__VITE_ASSET__ZrbjaLtb__"